export default __webpack_public_path__ + "static/media/supervillain_light-skin-tone_1f9b9-1f3fb_1f3fb.f1cf6faf.png";